module.exports = __webpack_public_path__ + "img/hys.7849fff0.png";